export default {
      id: "chantier-economie-sociale-usage",
      viewBox: "0 0 176 61",
      url: __webpack_public_path__ + "svg/sprite.svg#chantier-economie-sociale",
      toString: function () {
        return this.url;
      }
    }